const $ = (id) => document.getElementById(id);
const $$ = (sel) => document.querySelectorAll(sel);
let currentSellingPlans = [];
let basePrice = 0; //  global
let currentHandle = null;
let currentStep = 0;
const totalSteps = 5;
let isAdvancing = false;
let productVariants = [];
let currentVariant = null;

const answers = {
    brew: null,
    caffeine: null,
    roast: null,
    taste: null,
    quantity: null
};

let currentGalleryIndex = 0;

function init() {
    const urlParams = new URLSearchParams(window.location.search);
    let hasAnswersInUrl = false;

    Object.keys(answers).forEach(key => {
        if (urlParams.has(key)) {
            answers[key] = urlParams.get(key);
            hasAnswersInUrl = true;

            const radio = document.querySelector(`input[name="${key}"][value="${answers[key]}"]`);
            
            if (radio) {
                radio.checked = true;
                const option = radio.closest('.quiz-option');
                if (option) option.classList.add('selected');
            }
        }
    });

    setupEventListeners();

    if (hasAnswersInUrl) {
        showResults();
    } else {
        showStep(0);
        updateProgress();
    }
}



function showStep(step) {
    const quizSteps = $$('.quiz-step');
    const prevBtn = $('prevBtn');
    const nextBtn = $('nextBtn');

    quizSteps.forEach((s, i) => s.classList.toggle('active', i === step));

    if (prevBtn) prevBtn.style.display = step === 0 ? 'none' : 'inline-flex';

    if (nextBtn) {
        const currentStepEl = quizSteps[step];
        const hasSelection = currentStepEl?.querySelector('.quiz-option.selected');
        nextBtn.disabled = !hasSelection;
        nextBtn.innerHTML = step === totalSteps - 1 ? 'See Results →' : 'Continue →';
    }

    handleFadeIn(step);
}

function handleFadeIn(step) {
    const currentStepEl = $$('.quiz-step')[step];
    if (!currentStepEl) return;
    const fadeEls = currentStepEl.querySelectorAll('.fade-in');
    fadeEls.forEach(el => {
        el.classList.remove('visible');
        setTimeout(() => el.classList.add('visible'), 100);
    });
}

function updateProgress() {
    const progressSteps = $$('.progress-step');
    progressSteps.forEach((step, i) => {
        step.classList.remove('active', 'completed');
        if (i < currentStep) step.classList.add('completed');
        else if (i === currentStep) step.classList.add('active');
    });
}

function nextStep() {
    if (isAdvancing) return;
    isAdvancing = true;

    if (currentStep === 1 && answers.caffeine === 'decaf') {
        showResults();
        isAdvancing = false;
        return;
    }

    if (currentStep === 2 && (answers.roast === 'dark' || answers.roast === 'surprise')) {
        currentStep = 4;
    } else if (currentStep < totalSteps - 1) {
        currentStep++;
    } else {
        showResults();
        isAdvancing = false;
        return;
    }

    showStep(currentStep);
    updateProgress();
    setTimeout(() => (isAdvancing = false), 300);
}

function prevStep() {
    if (currentStep > 0) {
        if (currentStep === 4 && (answers.roast === 'dark' || answers.roast === 'surprise')) {
            currentStep = 2;
        } else {
            currentStep--;
        }
        showStep(currentStep);
        updateProgress();
    }
}

function setupEventListeners() {
    const startQuizBtn = $('startQuiz');
    const nextBtn = $('nextBtn');
    const prevBtn = $('prevBtn');
    const quizSection = $('quiz');

    if (startQuizBtn) {
        startQuizBtn.addEventListener('click', () => {
            currentStep = 0;
            quizSection?.scrollIntoView({ behavior: 'smooth' });
            showStep(0);
            updateProgress();
        });
    }

    if (nextBtn) nextBtn.addEventListener('click', nextStep);
    if (prevBtn) prevBtn.addEventListener('click', prevStep);

    $$('.quiz-option').forEach(option => {
        option.addEventListener('click', function () {
            const step = this.closest('.quiz-step');
            const input = this.querySelector('input');

            if (!step || !input) return;

            const name = input.name;
            const value = this.dataset.value;

            step.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));

            this.classList.add('selected');
            input.checked = true;
            answers[name] = value;
           
            setTimeout(nextStep, 250);
        });
    });
}

function showResults() {
    const resultsSection = $('results');
    const quizContainer = document.querySelector('.quiz-section');

    if (!resultsSection) return;



    if (quizContainer) {
        quizContainer.style.opacity = '0.6';
        quizContainer.style.pointerEvents = 'none';
    }

    fetchRecommendations(() => {
        if (quizContainer) {
            quizContainer.style.display = 'none';
            quizContainer.style.opacity = '1';
            quizContainer.style.pointerEvents = 'auto';
        }
        
        resultsSection.classList.add('active');
        const top = resultsSection.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top, behavior: 'smooth' });

        setTimeout(() => triggerConfetti(), 400);
        setTimeout(setupGallery, 100);
    });
}

function fetchRecommendations(onComplete) {
    const tags = Object.values(answers).filter(Boolean);
    const query = tags.map(tag => `tag:${tag}`).join(' AND ');
   
  
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=1')
        .then(res => res.json())
        .then(data => {
            const products = data.resources.results?.products || [];
            if (products.length === 0) {
             
                fetchFallback(tags.slice(0, tags.length - 1), onComplete);
            } else {
                renderProducts(products);
                if (onComplete) onComplete();
            }
        })
        .catch(err => {
            console.error('Error fetching recommendation', err);
            if (onComplete) onComplete();
        });
}


document.addEventListener("click", function (e) {

  const value = document.getElementById("qty12ozValue");
  const btn = document.querySelector(".continueBtn");

  if (!value.dataset.init && answers.quantity) {

  let qtyInit = answers.quantity.includes('lb') 
    ? 1 
    : parseInt(answers.quantity) || 1;

  value.innerText = qtyInit;

  value.dataset.init = "true";
  updatePrice(qtyInit);
}


  let qty = parseInt(value?.innerText) || 1;

  // =========================
  //  PLUS
  // =========================
  if (e.target.closest("#qtyPlus")) {
    qty++;
    value.innerText = qty;

    updateCTA(btn, qty);
    updatePrice(qty);
    return;
  }

  // =========================
  //  MINUS
  // =========================
  if (e.target.closest("#qtyMinus")) {
    if (qty > 1) qty--;
    value.innerText = qty;

    updateCTA(btn, qty);
    updatePrice(qty);
    return;
  }

  // =========================
  //  CTA CLICK
  // =========================
  if (e.target.closest(".continueBtn")) {
    e.preventDefault();

    if (!currentVariant) {
      console.error("No variant selected");
      return;
    }

    const select = document.getElementById("freq-select");
    let spQuery = "";
    if (select && select.value) {
      spQuery = "&selling_plan=" + select.value;
    }

    const addUrl = '/cart/add?id=' + currentVariant.id + '&quantity=' + qty + spQuery + '&return_to=/checkout';
    window.location.href = '/cart/clear?return_to=' + encodeURIComponent(addUrl);
    return;
  }

});

document.addEventListener("change", function(e) {
  if (e.target.id === "freq-select") {
    const qty = parseInt(document.getElementById("qty12ozValue")?.innerText) || 1;
    updatePrice(qty);
    updateCTA(document.querySelector(".continueBtn"), qty);
  }
});

function updateCTA(btn, qty) {
  if (!btn || !currentVariant) return;

  const select = document.getElementById("freq-select");
  let spQuery = "";
  if (select && select.value) {
    spQuery = "&selling_plan=" + select.value;
  }

  // We intentionally do not set btn.href here to prevent theme AJAX cart scripts
  // from intercepting the link and double-adding the item.
  // The redirection is handled purely by the click event listener above.
}

function getVariantBySize(size) {
  if (!productVariants || productVariants.length === 0) return null;

  return productVariants.find(v => {
    return v.title.toLowerCase().includes(size);
  });
}



function renderProducts(products) {
  
    if (!products || products.length === 0) return;

    const product = products[0];
    const resultsSection = document.getElementById('results');
    if (!resultsSection) return;

    // -------------------------
    // FORMAT PRICE
    // -------------------------4
    const formatMoney = (priceString) => {
        if (!priceString) return '';
        const val = parseFloat(priceString);
        return isNaN(val) ? priceString : '$' + val.toFixed(2);
    };

    basePrice = parseFloat(product.price) || 0;
    // -------------------------
    // BASIC PRODUCT DATA
    // -------------------------
    const titleEl = document.getElementById('coffeeName');
    if (titleEl) titleEl.innerText = product.title;

    const descEl = document.getElementById('coffeeDescription');
    if (descEl && product.body) descEl.innerHTML = product.body;

    const imageEl = document.getElementById('productImage');
    if (imageEl && product.image) {
        imageEl.src = product.image;
        imageEl.alt = product.title;

        const firstThumb = resultsSection.querySelector('.gallery-thumb img');
        if (firstThumb) firstThumb.src = product.image;
    }

    const productTagEl = document.getElementById('productTag');
    if (productTagEl) {
        const brew = answers.brew || '';
        const roast = answers.roast || '';
        productTagEl.innerText = `${brew} • ${roast}`.replace(/^[ •]+|[ •]+$/g, '');
    }

    // -------------------------
    // PRICE
    // -------------------------
    const priceFormatted = formatMoney(product.price);

    const mainPriceEl = resultsSection.querySelector('.price-main .price-amount');
    if (mainPriceEl) mainPriceEl.innerText = priceFormatted;

    const coffeeLinePriceEl = resultsSection.querySelector('.price-breakdown .price-line:first-child span:last-child');
    if (coffeeLinePriceEl) coffeeLinePriceEl.innerText = priceFormatted;

    // -------------------------
    // CTA LINK (CLEAN URL + QTY)
    // -------------------------
    const ctaLink = resultsSection.querySelector('.results-cta .btn-primary');

    if (ctaLink && product.url) {
        //  SAVE BASE URL
        ctaLink.setAttribute("data-url", product.url.split('?')[0]);
    }
fetch('/products/' + product.handle + '.js')
  .then(res => res.json())
  .then(fullProduct => {

    currentHandle = fullProduct.handle;
    productVariants = fullProduct.variants;

    //  DEFAULT VARIANT (12oz)
    currentVariant = productVariants.find(v =>
      v.title.toLowerCase().includes('12')
    ) || productVariants[0];

    basePrice = currentVariant.price / 100;

    const qty = parseInt(document.getElementById("qty12ozValue")?.innerText) || 1;
    console.log(fullProduct.selling_plan_groups);
    // DYNAMICALLY ADD SELLING PLAN OPTIONS
    // currentSellingPlans = fullProduct.selling_plan_groups[0]?.selling_plans || [];
    const rechargeGroup = fullProduct.selling_plan_groups.find(
  group => group.app_id
);

currentSellingPlans = rechargeGroup?.selling_plans || [];


    updateSellingPlanSelect(fullProduct);

    updatePrice(qty);
    updateCTA(document.querySelector(".continueBtn"), qty);
});

    
}



function triggerConfetti() {
    const container = document.createElement('div');
    container.className = 'confetti-container';
    document.body.appendChild(container);

    const colors = ['#FBC682', '#000', '#E5B06E', '#ffab00', '#333', '#fff'];
    const shapes = ['circle', 'square', 'line'];

    for (let i = 0; i < 150; i++) {
        const el = document.createElement('div');
        el.className = `confetti ${shapes[Math.floor(Math.random() * shapes.length)]}`;
        el.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        el.style.left = Math.random() * 100 + '%';
        el.style.top = '-20px';
        el.style.animationDelay = Math.random() + 's';
        el.style.animationDuration = (2 + Math.random()) + 's';
        const drift = (Math.random() - 0.5) * 200;
        el.style.setProperty('--drift', drift + 'px');
        container.appendChild(el);
    }
    setTimeout(() => container.remove(), 4000);
}

function setupFaqAccordion() {
    document.querySelectorAll('.faq-trigger').forEach(btn => {
        const item = btn.closest('.faq-item');
        const panel = item.querySelector('.faq-panel');
        btn.addEventListener('click', () => {
            const open = !item.classList.contains('is-open');
            item.classList.toggle('is-open', open);
            btn.setAttribute('aria-expanded', open);
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0';
        });
    });
}

function setupGallery() {
    const prevBtn = $('galleryPrev');
    const nextBtn = $('galleryNext');
    const thumbs = getVisibleThumbs();
    if (!thumbs.length) return;
    currentGalleryIndex = 0;
    setGalleryImage(currentGalleryIndex);
    thumbs.forEach((thumb, index) => {
        thumb.onclick = () => {
            currentGalleryIndex = index;
            setGalleryImage(index);
        };
    });
    if (prevBtn) {
        prevBtn.onclick = () => {
            const visible = getVisibleThumbs();
            currentGalleryIndex = (currentGalleryIndex - 1 + visible.length) % visible.length;
            setGalleryImage(currentGalleryIndex);
        };
    }
    if (nextBtn) {
        nextBtn.onclick = () => {
            const visible = getVisibleThumbs();
            currentGalleryIndex = (currentGalleryIndex + 1) % visible.length;
            setGalleryImage(currentGalleryIndex);
        };
    }
}

function getVisibleThumbs() {
    return Array.from(document.querySelectorAll('.gallery-thumb'))
        .filter(el => el.offsetParent !== null);
}

function setGalleryImage(index) {
    const visible = getVisibleThumbs();
    const mainImage = $('productImage');
    if (!visible[index] || !mainImage) return;
    const img = visible[index].querySelector('img');
    if (!img) return;
    mainImage.src = img.src;
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    visible[index].classList.add('active');
    currentGalleryIndex = index;
}

// document.addEventListener('DOMContentLoaded', () => {
//     setupFaqAccordion();
//     init();
//     setupGallery();
// });
// function updateSellingPlanSelect(fullProduct) {
//   const select = document.getElementById("freq-select");
//   if (!select) return;

//   const card = select.closest('.card');
//   select.innerHTML = '';

//   if (fullProduct.selling_plan_groups && fullProduct.selling_plan_groups.length > 0) {
//     if (card) card.style.display = 'block';
    
//     const group = fullProduct.selling_plan_groups[0];
//     group.selling_plans.forEach(plan => {
//       const option = document.createElement('option');
//       console
//       option.value = plan.id;
      
//       // Format text: "Delivery every 14 days" -> "Every 14 Days"
//       let label = plan.name.replace(/Delivery every/i, 'Every').trim();
//       label = label.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      
//       option.innerText = label;
      
//       // Default to 30 days if available
//       if (label.toLowerCase().includes('30')) {
//         option.selected = true;
//       }
      
//       select.appendChild(option);
//     });
    
//     // If no 30-day option was found, select the first one
//     if (select.selectedIndex === -1 && select.options.length > 0) {
//       select.options[0].selected = true;
//     }
//   } else {
//     if (card) card.style.display = 'none';
//   }
// }
function updateSellingPlanSelect(fullProduct) {

  const select = document.getElementById("freq-select");
  if (!select) return;

  select.innerHTML = '';

  // Find Recharge group
  const rechargeGroup = fullProduct.selling_plan_groups.find(
    group => group.app_id
  );

  if (!rechargeGroup) {
    console.log("Recharge group not found");
    return;
  }

  currentSellingPlans = rechargeGroup.selling_plans || [];

  currentSellingPlans.forEach(plan => {

    const option = document.createElement('option');

    option.value = plan.id;

    let label = plan.name
      .replace(/Delivery every/i, 'Every')
      .trim();

    option.textContent = label;

    select.appendChild(option);
  });

  // Default select 30 day if exists
  const thirtyDayOption = [...select.options].find(
    option => option.text.includes('30')
  );

  if (thirtyDayOption) {
    thirtyDayOption.selected = true;
  }
}


function updatePrice(qty) {
  const priceEl = document.querySelector('.price-main .price-amount');
  const breakdownEl = document.querySelector('.price-breakdown .price-line:first-child span:last-child');
  const select = document.getElementById("freq-select");

  if (!priceEl || !basePrice) return;
  if (!qty || qty < 1) qty = 1;

  let discountedBasePrice = basePrice;
  
  if (select && select.value && currentSellingPlans.length > 0) {
    const plan = currentSellingPlans.find(p => p.id.toString() === select.value.toString());
    if (plan && plan.price_adjustments && plan.price_adjustments.length > 0) {
      const adj = plan.price_adjustments[0];
      if (adj.value_type === 'percentage') {
        discountedBasePrice = basePrice * (1 - (adj.value / 100));
      } else if (adj.value_type === 'fixed_amount') {
        // Shopify fixed_amount is usually in cents for JS API, but let's check
        // If it's a large number (like 500 for $5), divide by 100.
        // Usually selling_plan_groups[].selling_plans[].price_adjustments[].value
        // is the raw number.
        discountedBasePrice = Math.max(0, basePrice - (adj.value / 100));
      } else if (adj.value_type === 'price') {
        discountedBasePrice = adj.value / 100;
      }
    }
  }

  const total = discountedBasePrice * qty;
  const formatted = '$' + total.toFixed(2);

  priceEl.innerText = formatted;

  if (breakdownEl) {
    breakdownEl.innerText = formatted;
  }
  
  updateShippingDesc(total);
}

function updateShippingDesc(totalPrice) {
  const shipDescEl = document.getElementById("ship-desc");
  const freqSelect = document.getElementById("freq-select");
  const priceDetailsEl = document.querySelector(".price-details");
  const shipping = document.querySelector(".price-line.shipping");

  let frequencyText = "on your selected schedule";
  if (freqSelect && freqSelect.options[freqSelect.selectedIndex]) {
     frequencyText = freqSelect.options[freqSelect.selectedIndex].text.trim().toLowerCase();
  }

  if (totalPrice >= 45) {
     if (shipDescEl) shipDescEl.innerText = `Deliveries ship ${frequencyText}. Free shipping included on this shipment.`;
    
     if (priceDetailsEl) priceDetailsEl.innerText = `✓ Free shipping applied`;
       priceDetailsEl.classList.add("free-shipping-applied");
       shipping.classList.add("hidden");
  } else {
     const remaining = (45 - totalPrice).toFixed(2);
     if (shipDescEl) shipDescEl.innerText = `Deliveries ship ${frequencyText}. $7.25 flat shipping this shipment. Add $${remaining} more in coffee for free shipping (orders $45+).`;
     if (priceDetailsEl) priceDetailsEl.innerText = `Free shipping over $45`;
        priceDetailsEl.classList.remove("free-shipping-applied"); 
        shipping.classList.remove("hidden");
  }
}
document.addEventListener('DOMContentLoaded', () => {

  init();
  setupFaqAccordion();
  setupGallery();

  //  DEFAULT PRODUCT FROM LIQUID
  if (window.defaultProduct) {

    productVariants = window.defaultProduct.variants;

    currentVariant = productVariants.find(v =>
      v.title.toLowerCase().includes('12')
    ) || productVariants[0];

    basePrice = currentVariant.price / 100;

    const qty = parseInt(document.getElementById("qty12ozValue")?.innerText) || 1;

    updatePrice(qty);

    // FETCH SELLING PLANS FOR DEFAULT PRODUCT
    fetch('/products/' + window.defaultProduct.handle + '.js')
      .then(res => res.json())
      .then(fullProduct => {
        // currentSellingPlans = fullProduct.selling_plan_groups[0]?.selling_plans || [];
        const rechargeGroup = fullProduct.selling_plan_groups.find(
  group => group.app_id
);
currentSellingPlans = rechargeGroup?.selling_plans || [];

        updateSellingPlanSelect(fullProduct);
        updatePrice(qty);
        updateCTA(document.querySelector(".continueBtn"), qty);
      });
  }

});



document.addEventListener("click", function (e) {


if (e.target.closest("#switchTo5lb")) {

  e.preventDefault();

  const variant = getVariantBySize('5'); //  use helper

  if (!variant) {
    console.error("5lb variant not found");
    return;
  }

  currentVariant = variant;
  basePrice = variant.price / 100;

  console.log("Selected 5lb variant:", currentVariant.id); //  debug

  document.getElementById("qty5lbBlock").style.display = "block";

  const qty = parseInt(document.getElementById("qty12ozValue")?.innerText) || 1;

  updatePrice(qty);
  updateCTA(document.querySelector(".continueBtn"), qty); //  VERY IMPORTANT
}

// =========================
// SWITCH TO 12oz
// =========================

if (e.target.closest("#switchTo12oz")) {

  e.preventDefault();

  const variant = getVariantBySize('12'); //  use helper

  if (!variant) {
    console.error("12oz variant not found");
    return;
  }

  currentVariant = variant;
  basePrice = variant.price / 100;

  console.log("Selected 12oz variant:", currentVariant.id); //  debug

  document.getElementById("qty5lbBlock").style.display = "none";

  const qty = parseInt(document.getElementById("qty12ozValue")?.innerText) || 1;

  updatePrice(qty);
  updateCTA(document.querySelector(".continueBtn"), qty); //  VERY IMPORTANT
}

});